import VGPopUp from 'components/Controls/VGPopUp';
import React, { Fragment } from 'react';
import { createPortal, unmountComponentAtNode } from 'react-dom';

const Mysitepopup = () => {

    const PopupTitle = () => {

    }

    const PopupBody = () => {
        return (
            <Fragment>
                <div className='vi-heading'>Try Out MySite: The New Web Builder!</div>
                <div className='video-discription'>Play around and build your website before committing to the website builder subscription.</div>
                <div>
                    <div className='featured-video-bg-promo'>
                        <div className="videowrapper-promo">
                        <iframe src="https://player.vimeo.com/video/871204184?share=copy" width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

    const Footer = () => {
        return (
            <Fragment>
                <button onClick={() => handlepopupClose()} className="w-button w-button-secondary">Close</button>
                <button onClick={() => handlepopupClose()} className="w-button w-button-primary">Try MySite</button>
            </Fragment>
        )
    }

    const handlepopupClose = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog"));
    }

    return createPortal(
        <VGPopUp
            show={true}
            title={PopupTitle()}
            onHide={handlepopupClose}
            body={PopupBody()}
            footer={Footer()}
            dialogClassName={"cancelauto-renew-alert promo-popup"}
            isShowFooter={true}
            id={"websitebuilderPromo"}
        />,
        document.getElementById("OpenDialog")
    )
}

export default Mysitepopup;
